/* NORELLE — small behaviours layered on Dawn. No dependencies. */
(() => {
  'use strict';

  /* ---------- 1. Header: solid once the page scrolls (overlay mode only) ---------- */
  const headerSection = document.querySelector('.section-header');
  if (headerSection && document.querySelector('.nr-header--overlay')) {
    let ticking = false;
    const update = () => {
      headerSection.classList.toggle('nr-header-solid', window.scrollY > 12);
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  /* ---------- 2. Globe add-on: add the accessory just before Dawn adds the lamp ---------- */
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.id) return;

      if (form.dataset.nrAccessoryDone === 'true') {
        delete form.dataset.nrAccessoryDone; // second pass: let Dawn handle it normally
        return;
      }

      const checkbox = document.querySelector(`[data-norelle-accessory][data-product-form="${CSS.escape(form.id)}"]`);
      if (!checkbox || !checkbox.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitter = event.submitter || form.querySelector('[type="submit"]');
      if (submitter) submitter.setAttribute('aria-busy', 'true');

      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(checkbox.dataset.variantId), quantity: 1 }] }),
      })
        .catch(() => null) // if the globe can't be added, still add the lamp
        .finally(() => {
          if (submitter) submitter.removeAttribute('aria-busy');
          form.dataset.nrAccessoryDone = 'true';
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        });
    },
    true // capture: runs before Dawn's product-form listener
  );

  /* ---------- 3. Mobile sticky Add to Cart ---------- */
  const bar = document.querySelector('[data-norelle-sticky-atc]');
  if (bar) {
    const sectionId = bar.dataset.section;
    const getMainButton = () => document.querySelector(`#product-form-${sectionId} [type="submit"]`);
    const priceTarget = bar.querySelector('[data-norelle-sticky-price]');
    const barButton = bar.querySelector('[data-norelle-sticky-button]');

    const sync = () => {
      const main = getMainButton();
      if (!main) return;
      const price = document.querySelector(`#price-${sectionId} .price-item--last`) ||
        document.querySelector(`#price-${sectionId} .price-item--regular`);
      if (price && priceTarget) priceTarget.textContent = price.textContent.trim();
      const disabled = main.hasAttribute('disabled') || main.getAttribute('aria-disabled') === 'true';
      barButton.disabled = disabled;
      const label = main.querySelector('span');
      if (label) barButton.textContent = label.textContent.trim();
    };

    barButton.addEventListener('click', () => {
      const main = getMainButton();
      if (main && !main.disabled) main.click();
    });

    const observe = () => {
      const main = getMainButton();
      if (!main || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(
        ([entry]) => {
          const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (past) sync();
          bar.classList.toggle('is-visible', past);
        },
        { threshold: 0 }
      ).observe(main);
    };

    // Dawn swaps the product form markup on variant change; re-sync and re-observe.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(() => {
        sync();
        observe();
      }, 50));
    }
    observe();
  }

  /* ---------- 4. Product details: open on desktop, accordions on mobile ---------- */
  const details = document.querySelectorAll('[data-norelle-details] [data-desktop-open]');
  if (details.length) {
    const mq = window.matchMedia('(min-width: 750px)');
    const apply = () => {
      details.forEach((el, i) => {
        if (mq.matches) el.setAttribute('open', '');
        else if (i > 0) el.removeAttribute('open');
      });
    };
    apply();
    mq.addEventListener('change', apply);
  }
})();
